import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { NewsletterService } from '../../../services/newsletter.service';

@Component({
  selector: 'app-newsletter-templates',
  templateUrl: './newsletter-templates.component.html',
  styleUrls: ['./newsletter-templates.component.scss']
})
export class NewsletterTemplatesComponent implements OnInit {

  templates: any[] = [];
  loading: boolean = false;
  errorMessage: string = '';

  // Editor
  editing: any = null;
  isNew: boolean = false;

  quillModules = {
    toolbar: [
      ['bold', 'italic', 'underline', 'strike'],
      [{ 'header': 1 }, { 'header': 2 }],
      [{ 'list': 'ordered' }, { 'list': 'bullet' }],
      [{ 'color': [] }, { 'background': [] }],
      [{ 'align': [] }],
      ['link', 'image'],
      ['clean']
    ]
  };

  constructor(
    private newsletterService: NewsletterService,
    private router: Router,
  ) {}

  ngOnInit(): void {
    this.load();
  }

  load(): void {
    this.loading = true;
    this.newsletterService.getTemplates().subscribe({
      next: (data) => {
        this.templates = data || [];
        this.loading = false;
      },
      error: () => {
        this.errorMessage = 'No se pudieron cargar las plantillas.';
        this.loading = false;
      }
    });
  }

  newTemplate(): void {
    this.editing = {
      id: null,
      name: '',
      description: '',
      subject: '',
      htmlContent: '',
      isSystem: false
    };
    this.isNew = true;
  }

  editTemplate(t: any): void {
    this.editing = { ...t };
    this.isNew = false;
  }

  cancelEdit(): void {
    this.editing = null;
    this.isNew = false;
  }

  save(): void {
    if (!this.editing.name.trim() || !this.editing.subject.trim() || !this.editing.htmlContent.trim()) {
      alert('Nombre, asunto y contenido son obligatorios.');
      return;
    }

    const payload = {
      name: this.editing.name.trim(),
      description: this.editing.description,
      subject: this.editing.subject.trim(),
      htmlContent: this.editing.htmlContent
    };

    const obs = this.isNew
      ? this.newsletterService.createTemplate(payload)
      : this.newsletterService.updateTemplate(this.editing.id, payload);

    obs.subscribe({
      next: () => {
        this.editing = null;
        this.isNew = false;
        this.load();
      },
      error: (err) => alert('Error: ' + (err.error || 'No se pudo guardar'))
    });
  }

  deleteTemplate(t: any): void {
    if (t.isSystem) {
      alert('No se pueden eliminar plantillas del sistema.');
      return;
    }
    if (!confirm('¿Eliminar la plantilla "' + t.name + '"?')) return;

    this.newsletterService.deleteTemplate(t.id).subscribe({
      next: () => this.load(),
      error: (err) => alert('Error: ' + (err.error || 'No se pudo eliminar'))
    });
  }

  goBack(): void {
    this.router.navigate(['/newsletter']);
  }
}

